<!-- /SectionTwo/ -->
<template>
  <div class="sectionTwoContainer">
    <h1 class="title">
      Le marché du crédit immobilier : mutations et perspectives
    </h1>
    <div class="bloksContainer">
      <div class="block">
        <div class="iconContainer">
          <Icon icon="ic:round-signal-cellular-alt" height="80" />
        </div>
        <div class="blockText">
          <span class="blockTitle">Les banques</span>
          <p class="text">
            Le renouvellement de la clientèle devient crucial face à la baisse de fréquentation des agences et à la
            concurrence des néo-banques. La nécessité de s'adapter s'impose, tant au niveau de l'organisation que de la
            productivité, pour répondre aux exigences accrues des emprunteurs.
          </p>
        </div>
      </div>
      <div class="block">
        <div class="iconContainer">
          <Icon icon="lucide:users" height="80" />
        </div>
        <div class="blockText">
          <span class="blockTitle">Les emprunteurs</span>
          <p class="text">
            En quête de la meilleure offre, ils expriment un besoin constant de conseil et d'accompagnement. La comparaison
            des offres du marché devient un élément essentiel dans leur processus de décision.
          </p>
        </div>
      </div>
      <div class="block">
        <div class="iconContainer">
          <Icon icon="uil:code" height="80" />
        </div>
        <div class="blockText">
          <span class="blockTitle">Les courtiers</span>
          <p class="text">
            Ils font face à la difficulté d'accéder à certaines banques tout en défendant
            les intérêts de leurs clients. </p>
        </div>
      </div>
    </div>
    <div>
      <div class="slider">
        <VueSlickCarousel v-bind="settings">
          <div class="block">
        <div class="iconContainer">
          <Icon icon="ic:round-signal-cellular-alt" height="80" />
        </div>
        <div class="blockText">
          <span class="blockTitle">Les banques</span>
          <p class="text">
            Le renouvellement de la clientèle devient crucial face à la baisse de fréquentation des agences et à la
            concurrence des néo-banques. La nécessité de s'adapter s'impose, tant au niveau de l'organisation que de la
            productivité, pour répondre aux exigences accrues des emprunteurs.
          </p>
        </div>
      </div>
      <div class="block">
        <div class="iconContainer">
          <Icon icon="lucide:users" height="80" />
        </div>
        <div class="blockText">
          <span class="blockTitle">Les emprunteurs</span>
          <p class="text">
            En quête de la meilleure offre, expriment un besoin constant de conseil et d'accompagnement. La comparaison
            des offres du marché devient un élément essentiel dans leur processus de décision.
          </p>
        </div>
      </div>
      <div class="block">
        <div class="iconContainer">
          <Icon icon="uil:code" height="80" />
        </div>
        <div class="blockText">
          <span class="blockTitle notranslate" translate="no">Les courtiers</span>
          <p class="text">
            Ils font face à la difficulté d'accéder à certaines banques et à la responsabilité d'aiguiller les dossiers
            dans le respect des intérêts des clients. </p>
        </div>
      </div>
        </VueSlickCarousel>
      </div>
    </div>
  </div>


</template>

<script>

import { Icon } from '@iconify/vue2';
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'


export default {
  name: 'SectionTwo',
  components: {
    Icon,
    VueSlickCarousel
  },
  data() {
    return {
      isSidebarOpen: false,
      settings: {
        "dots": true,
        "arrows": false,
        "dotsClass": "slick-dots ",
        "edgeFriction": 0.35,
        "infinite": false,
        "speed": 500,
        "slidesToShow": 1,
      },
      blocks: [
        {
          title: 'Les banques',
          icon: 'ic:round-signal-cellular-alt',
          text: 'Le renouvellement de la clientèle devient crucial face à la baisse de fréquentation des agences et à la concurrence des néo-banques. La nécessité de s\'adapter s\'impose, tant au niveau de l\'organisation que de la productivité, pour répondre aux exigences accrues des emprunteurs.'
        },
        {
          title: 'Les emprunteurs',
          icon: 'lucide:users',
          text: 'En quête de la meilleure offre, expriment un besoin constant de conseil et d\'accompagnement. La comparaison des offres du marché devient un élément essentiel dans leur processus de décision.'
        },
        {
          title: 'Les courtiers',
          icon: 'uil:code',
          text: 'Ils font face à la difficulté d\'accéder à certaines banques et à la responsabilité d\'aiguiller les dossiers dans le respect des intérêts des clients.'
        }
      ]
    };
  },
};
</script>


<style lang="scss">
@import './sectionTwo.scss'

</style>